export const TYPESTATU = {
  PHARMA : localStorage.getItem("setup") || '',
  HRCORE : 'HR Core', // HR CORE
  POORG : 'P&O Org', //Workday
  NONFF : 'NON FF' // HR CORE
}

export enum DivisionOrg {
  PHARMA = 'pharmaOrg',
  HRCORE = 'hrCoreOrg' ,// HR CORE
  POORG = 'P&O Org', //Workday
  NONFF = 'NonFf' // HR CORE
}
